<template>
  <div :class="{
    'progress-bar-container': true,
    'entire-fly-in': currentPage > 0 && currentPage < PAGE_AMOUNT,
    }"
  >
    <span class="time-text">1999</span>
    <div
      v-for="(item, index) in (PAGE_AMOUNT - 1)"
      :key="index"
      class="progress-rect"
      @mouseover="handleHover(true, index)"
      @mouseleave="handleHover(false, index)"
      @click="jumpToPage(index + 1)"
    >
      <div :class="{
          'progress-innter-rect': true,
          'fly-in': !isMob && hoverFlag && anchorHoverIndex === index,
          'fill': index === currentPage - 1,          
        }"
      >
        <div v-if="!isMob"
          :class="{
            'progress-rect-text': true,
          }"
        >
          {{anchorTitle[index]}}
        </div>
      </div>
    </div>
    <span class="time-text">2019</span>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    PAGE_AMOUNT: {
      type: Number,
      require: true,
    },
    currentPage: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      hoverFlag: false,
      anchorHoverIndex: 0,
      anchorTitle: ['Devouring Earthquake that Lasted for 102 Seconds', 'The Quake of the Century', 'Houses broke down', 'Uncertainty of the Future', 'But “Home” Still Stands', 'Reconstruction and Rebirth', 'Changes Happend During the Twenty Years  ', 'Fight For More Surviving Time', 'The Government Did Nothing', 'Our Home Is Still in Danger', 'We Repeated the Same Mistake', 'Fifty Percent Structures Are Unsafe in Taiwan', 'If 921 Earthquake Hits Again'],
    };
  },
  computed: {
    isMob() {
      return window.innerWidth < 1280 ? true : false; 
    },
  },
  methods: {
    jumpToPage(index) {
      this.$root.$children[0].currentPage = index;
    },
    handleHover(flag, index) {
      if (!this.isMob) {
        this.hoverFlag = flag;
        this.anchorHoverIndex = index;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.progress-bar-container {
  position: fixed;
  z-index: 5001;
  top: 0;
  left: 0;
  height: 100vh;
  padding: 10vh 0 15vh 0;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  transform: translateX(-100px);
  transition: .666s ease-in-out;
  .time-text {
    // margin: 5px 0;
    margin: initial;
    padding: 3px 0;
    writing-mode: vertical-rl;
    font-size: 14px;
    color: #7b7a7a;
  }
  .progress-rect {
    position: relative;
    height: 100%;
    width: 10px;
    margin: 3px 11px;
    overflow: hidden;
    cursor: pointer;
    transition: .666s ease-in-out;
    @media only screen and (min-width: 1280px) {
      width: 50px;
      &:hover {
        width: 250px;
      }
    }
    .progress-innter-rect {
      position: absolute;
      top: 0;
      left: 2px;
      height: 100%;
      width: 250px;
      background-color: #7b7a7a;
      transform: translateX(-250px);
      transition: .666s ease-in-out;
      .progress-rect-text {
        position: relative;
        height: 100%;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: .666s ease-in-out;
        padding: 10px;
        text-align: left;
      }
    }
    .fill {
      background-color: #c3dddd;
    }
    .fly-in {
      transform: translateX(-2px);
    }
  }
}
.entire-fly-in {
  transform: translateX(0);
}
</style>
